import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "12.838",
  height: "11.087"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      fill: "none",
      stroke: "#626997",
      "stroke-width": "1.5",
      "data-name": "Arrow IDŹ DO"
    }, [
      _createElementVNode("path", {
        "stroke-linecap": "square",
        d: "M.75 5.539h10.5",
        "data-name": "Line 521"
      }),
      _createElementVNode("path", {
        d: "m6.492.543 5.257 5-5.257 5",
        "data-name": "Path 16163"
      })
    ], -1)
  ]))]))
}
export default { render: render }